export default function FrameIcon() {
  return (
    <>
      <g id='Frame' clipPath='url(#clip0_2886_7671)'>
        <path
          id='noun-shield-5196407'
          d='M5.05703 21.3623L9.38602 24.1713C9.71682 24.3864 10.1029 24.5009 10.4975 24.5009C10.8921 24.5009 11.2782 24.3864 11.609 24.1713L15.938 21.3633C17.4932 20.3612 18.7717 18.9845 19.6562 17.3595C20.5407 15.7346 21.0028 13.9134 21 12.0633V5.60833C21.0003 5.11621 20.8238 4.64036 20.5026 4.26754C20.1813 3.89472 19.7368 3.64976 19.25 3.57733C16.5253 3.19149 13.9097 2.2471 11.567 0.803333C11.2477 0.605064 10.8794 0.5 10.5035 0.5C10.1277 0.5 9.75931 0.605064 9.44002 0.803333C7.09489 2.24752 4.47696 3.19222 1.75002 3.57833C1.26325 3.65076 0.818723 3.89572 0.497485 4.26854C0.176247 4.64136 -0.000304155 5.11721 1.83628e-05 5.60933V12.0603C-0.00335434 13.91 0.457922 15.7308 1.34151 17.3558C2.2251 18.9807 3.5027 20.3577 5.05703 21.3603V21.3623ZM6.46903 11.2923C6.64152 11.1201 6.87529 11.0234 7.11902 11.0234C7.36276 11.0234 7.59654 11.1201 7.76903 11.2923L9.36902 12.8973L13.224 9.03433C13.3996 8.87495 13.6298 8.78934 13.8669 8.7953C14.1039 8.80125 14.3296 8.89831 14.4969 9.06631C14.6643 9.2343 14.7605 9.46032 14.7655 9.69739C14.7706 9.93447 14.6841 10.1644 14.524 10.3393L10.018 14.8543C9.93268 14.9397 9.83135 15.0075 9.71982 15.0537C9.60829 15.0999 9.48875 15.1237 9.36803 15.1237C9.2473 15.1237 9.12775 15.0999 9.01622 15.0537C8.90469 15.0075 8.80336 14.9397 8.71802 14.8543L6.47002 12.5923C6.29727 12.4191 6.20026 12.1845 6.20026 11.9398C6.20026 11.6952 6.29727 11.4605 6.47002 11.2873L6.46903 11.2923Z'
          fill='#4D7225'
        />
      </g>
      <defs>
        <clipPath id='clip0_2886_7671'>
          <rect
            width='21'
            height='24'
            fill='white'
            transform='translate(0 0.5)'
          />
        </clipPath>
      </defs>
    </>
  );
}
